import { render, staticRenderFns } from "./MainButtonVue.vue?vue&type=template&id=50b3e459&scoped=true&"
import script from "./MainButtonVue.vue?vue&type=script&lang=js&"
export * from "./MainButtonVue.vue?vue&type=script&lang=js&"
import style0 from "./MainButtonVue.vue?vue&type=style&index=0&id=50b3e459&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b3e459",
  null
  
)

export default component.exports